import { placeOrderApiClient } from "@api-client/place_order";
import type { ResType } from '@api-client/typeUtils';
import { thermalPrinterFormat } from "@lib/utils/printerFormat";
import { toast } from "@iframe-widgets/pages/widgets/toast/iframeToast";
const orderDetailsApiPath = placeOrderApiClient[":storeOrderId"].get_order.$post;
type OrderType = ResType<typeof orderDetailsApiPath>["data"]['order'];

export const LOCALSTORAGE_KEYS = {
    FONT_SIZE_REM: 'FONT_SIZE_REM',
    FONT_WEIGHT: 'FONT_WEIGHT',
}

async function putHtmlInWindow(doc: Document, html: string) {
    await new Promise((r) => setTimeout(r, 200));
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    doc.replaceChild(
        doc.importNode(parsed.documentElement, true),
        doc.documentElement,
    );
}

export const printOrder = (
    orderDetails: OrderType,
    locale: string | undefined = undefined
) => {
    const fontSizeRem = localStorage.hasOwnProperty(LOCALSTORAGE_KEYS.FONT_SIZE_REM) ? Number(localStorage.getItem(LOCALSTORAGE_KEYS.FONT_SIZE_REM)) : 0.8;
    const fontWeight = localStorage.getItem(LOCALSTORAGE_KEYS.FONT_WEIGHT) as 'normal' | 'bold' ?? 'normal';
    const html = thermalPrinterFormat(orderDetails, locale, fontSizeRem, fontWeight);

    const popup = window.open('about:blank', '_blank');
    if (!popup) {
        toast.error('Popup blocked');
        return;
    }

    void (async () => {
        await putHtmlInWindow(popup.document, html);
        try {
            popup.print();
            await new Promise((r) => setTimeout(r, 1000));
        } finally {
            popup.close();
        }
    })();
}